module.exports = __webpack_public_path__ + "static/media/kim.d7d0f9f5.png";